angular.module( 'acme.view.application.passes.create.modals.publish', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.passes.create.modals.publish.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var passesCreateModalsPublish = {
        name: 'application.passes.create.modals.publish',
        url: '/passes/create/modals/publish',
        views: {
          "main": {
            controller: 'PassesCreateModalsPublishController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/passes/create/modals/publish/publish.tpl.html'
          }
        },
        data: {
          pageTitle: '    ',
          /** Secure With Permissions **/
          permissions: []
        }
      };

    $stateProvider
      .state(passesCreateModalsPublish);
});
